import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import { useEventCalendarValues } from "../../../routes/calendar/calendar-context";

const dayOptions: Array<{ day: number; label: string }> = [
  { day: 0, label: "S" },
  { day: 1, label: "M" },
  { day: 2, label: "T" },
  { day: 3, label: "W" },
  { day: 4, label: "T" },
  { day: 5, label: "F" },
  { day: 6, label: "S" },
];

const ShowDaysFilter: React.FC = () => {
  const { visibleWeekDays, toggleVisibleWeekDay } = useEventCalendarValues();

  return (
    <Stack direction="row" spacing={1} justifyContent="space-between">
      {dayOptions.map(({ day, label }) => {
        const isSelected = visibleWeekDays.includes(day);

        return (
          <Box
            key={`${day}-${label}`}
            component="button"
            type="button"
            onClick={() => toggleVisibleWeekDay(day)}
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              border: isSelected ? "1px solid #1F6CB5" : "1px solid #C7D2DE",
              backgroundColor: isSelected ? "#1F6CB5" : "#FFFFFF",
              color: isSelected ? "#FFFFFF" : "#607080",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease",
              "&:hover": {
                borderColor: "#1F6CB5",
                color: isSelected ? "#FFFFFF" : "#1F6CB5",
              },
            }}
          >
            <Typography sx={{ fontSize: "0.8rem", fontWeight: 700, lineHeight: 1 }}>
              {label}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
};

export default ShowDaysFilter;